module.exports = __webpack_public_path__ + "img/icon_desk-1.5f15a8da.png";